import { useState } from "react";
import { IChart } from "../../../../../@types/chart.type";
import iconDelete from "./../../../../../assets/_TrashIcon_gray.svg";
import { GridBaseWidget } from "../../GridBaseWidget";
import { ColDef, IGetRowsParams } from "ag-grid-community";
import { getAllProjectWithoutBudget } from "../../../../../services/api/widgets/widgetsService";
import { IApiResponse } from "../../../../../@types/api-response.type";
import { storageUserGet } from "../../../../../storage/storageUser";
import {
  ProjectsWithoutBudgetsDto,
} from "../../../../../@types/widgets.type";
import { IconProjectsWithoutABudget } from "../../../../../icons/IconProjectsWithoutABudget";
import styles from "./styles.module.scss";

interface ProjectsWithoutABudgetProps {
  chart: IChart;
  ismodeEdit: boolean;
  deleteChart: (id: string | undefined, widgetId: string) => void;
  rowHeightGrid: number;
}

const columns: ColDef[] = [
  {
    field: "id",
    headerName: "ID",
    hide: true,
  },
  {
    field: "projectName",
    headerName: "Projeto",
    flex: 1,
  },
  {
    field: "projectManager",
    headerName: "Gestor",
    flex: 1,
  },
  {
    field: "projectStatus",
    headerName: "Status",
    flex: 1,
  },
];

export function ProjectsWithoutABudget({
  chart,
  deleteChart,
  ismodeEdit,
}: ProjectsWithoutABudgetProps) {
  const [loading, setLoading] = useState<boolean>(false);

  const user = storageUserGet();

  async function fetchAllProjectWithoutBudget(params: IGetRowsParams) {
    const skip = params.startRow; // Linha inicial para paginação
    const take = params.endRow - params.startRow; // Quantidade de linhas

    try {
      setLoading(true);
      const response = (await getAllProjectWithoutBudget(
        skip,
        take,
        user.email,
        user?.resourceId as string
      )) as IApiResponse<ProjectsWithoutBudgetsDto>;

      if (response.statusCode === 200) {
        params.successCallback(
          response.result.projectWithoutBudget,
          response.result.projectWithoutBudgetCount
        );
      }
    } catch (error) {
      console.log(error);
      params.failCallback();
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className={styles.widget}>
      <div className={styles.header}>
        <h3>
          <IconProjectsWithoutABudget size={34} />
          Projetos sem Orçamento no Mês
        </h3>
      </div>
      <div style={{ width: "100%", height: "100%" }}>
        <GridBaseWidget
          columns={columns}
          fetchData={fetchAllProjectWithoutBudget}
          loading={loading}
        />
      </div>
      {ismodeEdit && (
        <button onClick={() => deleteChart(chart.id, chart.widgetId)}>
          <img src={iconDelete} alt="" />
        </button>
      )}
    </div>
  );
}
